import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMissingTranslationHandler
  implements MissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams) {
    if (params.key.includes('.') && params.key.split('.').length > 0) {
      console.warn(
        `Missing translation for key: ${params.key} in language: ${params.translateService.currentLang}`
      );
    }
    return params.key;
  }
}
